var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',[(_vm.tableData.length <= 0)?[_vm._m(0)]:[_vm._t("default")]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"full-colspan",attrs:{"colspan":"100"}},[_c('p',[_vm._v("No Data Found.")])])
}]

export { render, staticRenderFns }